// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.count-config-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
}

.count-config-header {
  margin-bottom: 2rem;
}

.count-config-header h1 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.count-config-header p {
  color: #666;
  font-size: 1rem;
}

.count-config-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

@media (max-width: 1024px) {
  .count-config-content {
    grid-template-columns: 1fr;
  }
}

.config-form {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 2rem;
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-section h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 0.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: 500;
  font-size: 0.9rem;
}

.form-group input[type="text"],
.form-group input[type="number"] {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.form-group input[type="text"]:focus,
.form-group input[type="number"]:focus {
  outline: none;
  border-color: #5865f2;
}

.form-group input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.color-picker-group {
  position: relative;
}

.color-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.color-input-wrapper input[type="color"] {
  width: 60px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.color-input-wrapper input[type="color"]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.color-input-wrapper .color-hex {
  flex: 1 1;
  width: auto;
}

.color-icon {
  color: #888;
  font-size: 1.2rem;
}

.toggle-group {
  margin-bottom: 1rem;
}

.toggle-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.toggle-label:hover {
  background: #e9ecef;
}

.toggle-label input[type="checkbox"] {
  margin-right: 0.75rem;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.toggle-label input[type="checkbox"]:disabled {
  cursor: not-allowed;
}

.toggle-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #555;
  font-weight: 500;
}

.toggle-text svg {
  font-size: 1.1rem;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #f0f0f0;
}

.save-btn,
.reset-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.save-btn {
  background: #5865f2;
  color: white;
  flex: 1 1;
}

.save-btn:hover:not(:disabled) {
  background: #4752c4;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(88, 101, 242, 0.3);
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.reset-btn {
  background: #f0f0f0;
  color: #555;
}

.reset-btn:hover {
  background: #e0e0e0;
}

.preview-section {
  position: sticky;
  top: 2rem;
  height: fit-content;
}

.preview-section h2 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
}

.embed-preview {
  background: #2f3136;
  border-radius: 4px;
  border-left: 4px solid #5865f2;
  padding: 1rem;
  color: #dcddde;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.embed-header h3 {
  color: #ffffff;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.embed-description {
  color: #b9bbbe;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.embed-fields {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 0.5rem;
}

.embed-field {
  grid-column: span 3;
}

.embed-field.inline {
  grid-column: span 1;
}

.field-name {
  color: #ffffff;
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.field-value {
  color: #dcddde;
  font-size: 0.9rem;
}

.embed-footer {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #4f5058;
  font-size: 0.75rem;
  color: #b9bbbe;
}

.alert {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.alert-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CountConfig.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".count-config-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.count-config-header {\n  margin-bottom: 2rem;\n}\n\n.count-config-header h1 {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.count-config-header p {\n  color: #666;\n  font-size: 1rem;\n}\n\n.count-config-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n}\n\n@media (max-width: 1024px) {\n  .count-config-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n.config-form {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.form-section {\n  margin-bottom: 2rem;\n}\n\n.form-section:last-child {\n  margin-bottom: 0;\n}\n\n.form-section h2 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  color: #333;\n  border-bottom: 2px solid #f0f0f0;\n  padding-bottom: 0.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #555;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"] {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.3s;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #5865f2;\n}\n\n.form-group input:disabled {\n  background-color: #f5f5f5;\n  cursor: not-allowed;\n}\n\n.color-picker-group {\n  position: relative;\n}\n\n.color-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.color-input-wrapper input[type=\"color\"] {\n  width: 60px;\n  height: 40px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.color-input-wrapper input[type=\"color\"]:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.color-input-wrapper .color-hex {\n  flex: 1;\n  width: auto;\n}\n\n.color-icon {\n  color: #888;\n  font-size: 1.2rem;\n}\n\n.toggle-group {\n  margin-bottom: 1rem;\n}\n\n.toggle-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0.75rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n  transition: background-color 0.3s;\n}\n\n.toggle-label:hover {\n  background: #e9ecef;\n}\n\n.toggle-label input[type=\"checkbox\"] {\n  margin-right: 0.75rem;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.toggle-label input[type=\"checkbox\"]:disabled {\n  cursor: not-allowed;\n}\n\n.toggle-text {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #555;\n  font-weight: 500;\n}\n\n.toggle-text svg {\n  font-size: 1.1rem;\n}\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid #f0f0f0;\n}\n\n.save-btn,\n.reset-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.save-btn {\n  background: #5865f2;\n  color: white;\n  flex: 1;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: #4752c4;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(88, 101, 242, 0.3);\n}\n\n.save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.reset-btn {\n  background: #f0f0f0;\n  color: #555;\n}\n\n.reset-btn:hover {\n  background: #e0e0e0;\n}\n\n.preview-section {\n  position: sticky;\n  top: 2rem;\n  height: fit-content;\n}\n\n.preview-section h2 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.embed-preview {\n  background: #2f3136;\n  border-radius: 4px;\n  border-left: 4px solid #5865f2;\n  padding: 1rem;\n  color: #dcddde;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.embed-header h3 {\n  color: #ffffff;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.embed-description {\n  color: #b9bbbe;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.embed-fields {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.embed-field {\n  grid-column: span 3;\n}\n\n.embed-field.inline {\n  grid-column: span 1;\n}\n\n.field-name {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 0.85rem;\n  margin-bottom: 0.25rem;\n}\n\n.field-value {\n  color: #dcddde;\n  font-size: 0.9rem;\n}\n\n.embed-footer {\n  margin-top: 1rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid #4f5058;\n  font-size: 0.75rem;\n  color: #b9bbbe;\n}\n\n.alert {\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.alert-success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.alert-error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.alert-info {\n  background: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
